import React, { Component } from "react";
import { Button, Header, Modal, ModalActions, Icon } from "semantic-ui-react";
import axios from "axios";

class LogInModal extends Component {
  state = {
    email: "",
    resetOK: false,
    resetNotOK: false,
    modalOpen: false
  };

  handleSetEmail = event => {
    const email = event.target.value;
    this.setState({ email });
  };

  handleKeyUp = event => {
    if (event.key === "Enter") {
      this.handleResetPassword();
    }
  };

  handleResetPassword = () => {
    const { email } = this.state;
    const passwordInfo = {
      type: "vendor",
      email
    };
    axios.post("/api/users/reset", passwordInfo).then(res => {
      if (res.status === 200) {
        this.setState({ resetOK: true, modalOpen: false });
      } else {
        this.setState({ resetNotOK: true, modalOpen: false });
      }
    });
  };

  handleOpen = () => {
    this.setState({
      modalOpen: true
    });
  };

  handleCloseModal = () => {
    const { resetOK } = this.state;
    if (resetOK === true) {
      this.setState({ resetOK: false, modalOpen: false });
    } else {
      this.setState({ resetNotOK: false, modalOpen: false });
    }
  };

  render() {
    const { email, resetOK, resetNotOK, modalOpen } = this.state;

    const modalOK = (
      <div>
        <Modal
          open={resetOK}
          closeOnDimmerClick
          closeOnEscape
          onClose={this.handleCloseModal}
        >
          <Modal.Header>
            Your password has been changed and sent to your email address!
          </Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <p>Press OK to go back to Login Page</p>
            </Modal.Description>
          </Modal.Content>
          <ModalActions>
            <Button onClick={this.handleCloseModal}>OK</Button>
          </ModalActions>
        </Modal>
      </div>
    );

    const modalNotOK = (
      <div>
        <Modal
          open={resetNotOK}
          closeOnDimmerClick
          closeOnEscape
          onClose={this.handleCloseModal}
        >
          <Modal.Header>Error! Password couldn&apos;t be changed!</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <p>Press OK to go back to Login Page</p>
            </Modal.Description>
          </Modal.Content>
          <ModalActions>
            <Button onClick={this.handleCloseModal}>OK</Button>
          </ModalActions>
        </Modal>
      </div>
    );

    const modal = (
      <div>
        <Modal
          trigger={<Button onClick={this.handleOpen}>Forgot Password?</Button>}
          open={modalOpen}
          closeOnDimmerClick
          closeOnEscape
          onClose={this.handleCloseModal}
        >
          {" "}
          <Modal.Header>
            Have you forgot your password? No worries, we&apos;ve got you
            covered!
          </Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <Header>Reset your Password</Header>
              <p>Just type in your email address and click Send.</p>
              <input
                type="text"
                onChange={this.handleSetEmail}
                onKeyUp={this.handleKeyUp}
                value={email}
                id="eInput"
              />
            </Modal.Description>
          </Modal.Content>
          <ModalActions>
            <Button color="green" onClick={this.handleResetPassword} id="eBtn">
              <Icon name="checkmark" />
              Send
            </Button>
          </ModalActions>
        </Modal>
      </div>
    );

    return (
      <div>
        {modal}
        {modalOK}
        {modalNotOK}
      </div>
    );
  }
}

export default LogInModal;
